import { locales } from '@uturn/portal/i18n';
import { z } from '@uturn/portal/zod';
import { formValidationMessage } from '@uturn/portal/zod/utils';

export const PASSWORD_MIN_LENGTH = 8;

/** Special characters accepted by the backend password policy. @see CreateUser */
export const PASSWORD_SPECIAL_CHARACTERS = '!@#$%^&*()_+-={};:<>?';

const PASSWORD_PATTERNS = {
	uppercase: /[A-Z]/,
	lowercase: /[a-z]/,
	digit: /\d/,
	special: /[!@#$%^&*()_+\-={};:<>?]/,
};

const isStrongPassword = (value: string) =>
	value.length >= PASSWORD_MIN_LENGTH &&
	PASSWORD_PATTERNS.uppercase.test(value) &&
	PASSWORD_PATTERNS.lowercase.test(value) &&
	PASSWORD_PATTERNS.digit.test(value) &&
	PASSWORD_PATTERNS.special.test(value);

//  Mirrors the backend password policy validation

const password = z.string().superRefine((value, ctx) => {
	if (!isStrongPassword(value)) {
		ctx.addIssue({
			code: z.ZodIssueCode.custom,
			message: locales.t('password_requirements_not_met', {
				ns: 'formValidation',
				defaultValue: "Password doesn't meet the requirements below.",
			}),
		});
	}
});

export const passwordResetSchema = z
	.object({
		password,
		confirmPassword: z.string(),
	})
	.superRefine(({ password, confirmPassword }, ctx) => {
		if (password !== confirmPassword) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				path: ['confirmPassword'],
				...formValidationMessage('passwords_do_not_match'),
			});
		}
	});

export type PasswordResetFormValues = z.infer<typeof passwordResetSchema>;
